module.exports = __webpack_public_path__ + "static/pkc.07a5b591.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/pkc.gif
// module id = 129
// module chunks = 164155623112449 263791100135453